<template>
  <v-card outlined>
    <div>
      <v-card-title
        class="subtitle-3 d-flex"
        style="word-break: normal; justify-content: space-evenly; flex-wrap: nowrap"
      >
        <v-btn class="text-capitalize" depressed elevation="8" fab dark @click="goToPreviousStep()">
          <v-icon size="20" v-text="icons.mdiArrowLeft"></v-icon>
        </v-btn>
        <span class="text-h4 pl-5 pr-5">{{ translations.customerReward[lang] }}</span>

        <v-btn
          class="text-capitalize"
          depressed
          :elevation="(canGoToNextStep && !this.loading && 8) || 0"
          dark
          fab
          :disabled="!canGoToNextStep || loading"
          @click="goToNextStep()"
        >
          <v-icon size="20" v-text="icons.mdiArrowRight"></v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="text--primary pt-5">
        <!-- <v-btn @click="()=>{allRewards.push(allRewards[0])}"></v-btn> -->
        <v-row>
          <v-col :class="['transition-all']" cols="12" sm="12">
            <v-col cols="12" sm="12" class="d-flex justify-center">
              <div
                style="position: absolute; max-width: 650px; width: 100%; overflow: visible"
                class="d-flex flex-column transition-all"
                v-if="!rewardLoading"
              >
                <div
                  class="mb-1 d-flex align-center transition-all"
                  v-for="(item, index) in selectedRewards"
                  :key="index"
                  style="height: 94px; width: 100%; overflow: visible"
                >
                  <v-card
                    :elevation="selectedRewards.filter((x) => x.priority).length > index ? 6 : 0"
                    class="pa-4 d-flex justify-start align-center rounded-pill rounded-r-lg transition-all"
                    style="height: 100%; max-height: 70px"
                    :disabled="
                      !item.priority || index >= selectedRewards.filter((x) => x.priority).length
                    "
                    :class="'no-right-shadow'"
                  >
                    <span
                      class="font-weight-bold text-left text-h3"
                      :class="[
                        selectedRewards.filter((x) => x.priority).length > index ? '' : 'invisible',
                      ]"
                      >{{ index + 1 }}</span
                    >
                  </v-card>
                </div>
                <div
                  class="mb-10 d-flex align-center transition-all mt-0 transition-mgt-0"
                  style="height: 94px; width: 100%; overflow: visible"
                  :class="addBtnHeadClasses"
                >
                  <v-card
                    :elevation="6"
                    class="pa-4 d-flex justify-start align-center rounded-pill rounded-r-lg transition-all"
                    style="height: 100%; max-height: 70px; min-width: 61px"
                    :class="'no-right-shadow'"
                  >
                    <span class="font-weight-bold text-left text-h3"></span>
                  </v-card>
                </div>
              </div>

              <Container
                @drop="onDrop"
                drag-handle-selector=".column-drag-handle"
                style="position: relative; width: 100%"
                :style="{
                  'max-width': '600px',
                  'min-width': 'auto',
                }"
                class="ml-4 d-flex drag-cont flex-column justify-center transition-all"
              >
                <Draggable
                  v-for="(reward, index) in selectedRewards || [{}]"
                  :key="reward.name"
                  class="pl-0 transition-all"
                  style="overflow: visible"
                >
                  <v-skeleton-loader
                    v-if="rewardLoading"
                    class="d-flex justify-center transition-all mw-100 campaign-actions conditions-loader mb-12 mt-4 ml-7"
                    :types="{ actions: 'button@1' }"
                    type="actions"
                  ></v-skeleton-loader>
                  <div
                    v-else
                    style="position: relative"
                    :style="{
                      'min-width': '386px',
                    }"
                    class="ml-4 d-flex justify-center"
                  >
                    <v-col
                      style="cursor: pointer"
                      class="draggable-item rounded-pill mb-1 pl-0"
                      cols="12"
                      sm="12"
                    >
                      <v-hover v-slot="{ hover }">
                        <v-card
                          style="max-height: 70px; max-width: 600px"
                          :style="{
                            'min-width': '350px',
                            'max-width': '600px',
                          }"
                          :elevation="((hover && 4) || 0) + ((reward.priority && 4) || 0)"
                          class="mx-auto pl-2 ml-4 d-flex flex-row align-center rounded-pill transition-all"
                          :class="[
                            reward.priority && 'rounded-l-lg',

                            reward.valid
                              ? 'background-fill-transition-valid'
                              : (reward.valid === false && 'background-fill-transition-error') ||
                                'background-fill-transition',
                            reward.priority &&
                            selectedRewards.filter((x) => x.priority).length > index
                              ? `background-fill-left no-left-shadow`
                              : 'background-empty',
                          ]"
                        >
                          <v-tooltip color="secondary" top>
                            <template v-slot:activator="{ on }">
                              <v-btn
                                style="display: none"
                                color="secondary"
                                icon
                                v-on="on"
                                class="transition-all"
                                :class="[!reward.reward_id ? 'invisible' : '']"
                              >
                                <span
                                  class="column-drag-handle transition-all"
                                  style="
                                    float: left;
                                    cursor: pointer;
                                    padding: 10px 15px;
                                    font-size: 24px;
                                  "
                                  >&#x2630;</span
                                >
                              </v-btn>
                            </template>
                            <span class="font-weight-bold" v-text="translations.drag[lang]"></span>
                          </v-tooltip>
                          <div
                            class="pa-6 pl-2 d-flex flex-row justify-center align-items-center pr-0"
                            style="min-width: 100px; width: 90%"
                          >
                            <v-card
                              color="rgba(255,255,255,0)"
                              flat
                              class="d-flex flex-row align-center ml-0 pl-2 pr-2 mw-100 transition-all"
                              :disabled="!reward.priority"
                              :class="[(reward.priority && ' font-weight-bold') || 'ml-16']"
                            >
                              <v-autocomplete
                                v-if="!reward.reward_id"
                                prepend-inner-icon="mdi-gift"
                                :items="filteredRewards"
                                v-model="reward.reward_id"
                                item-text="title"
                                item-value="reward_id"
                                menu-props="offsetY"
                                :label="translations.selectReward[lang]"
                                class="mt-0"
                                outlined
                                dense
                                hide-details
                                :search-input.sync="searchRewards"
                                :loading="loading"
                                :disable-lookup="true"
                                @change="saveRewardData(index, reward)"
                              >
                                <template v-slot:append-item>
                                  <div v-intersect="endIntersectRewards"></div>
                                  <v-list-item v-if="loading">
                                    <v-list-item-action class="ml-1">
                                      <v-row class="d-flex align-center">
                                        <v-btn
                                          class="text-capitalize"
                                          depressed
                                          fab
                                          small
                                          :loading="true"
                                          style="background: transparent"
                                        >
                                        </v-btn>
                                        <span class="pa-2">{{ translations.loadMore[lang] }}</span>
                                      </v-row>
                                    </v-list-item-action>
                                  </v-list-item>
                                </template>
                              </v-autocomplete>
                              <div class="d-flex mw-100 align-center" v-else>
                                <!-- <span>{{ reward.reward_id }}</span> -->
                                <v-text-field
                                  style="width: 350px"
                                  class="px-3 pt-0 justify-center pr-2 mt-n1"
                                  :class="'mr-auto'"
                                  :value="getRewardData(reward).title"
                                  :label="translations.selectedReward[lang]"
                                  hide-details
                                  prepend-icon="mdi-gift"
                                  append-icon="mdi-close-circle"
                                  readonly
                                  full-width
                                  single-line
                                  outlined
                                  dense
                                  @click:append="clearRewardIdOnNull(reward)"
                                ></v-text-field>
                                <b-text-field
                                  style="max-width: 155px"
                                  class="d-flex justify-center align-center pt-0 mt-n1"
                                  :class="'mr-auto'"
                                  v-model="reward.count"
                                  :label="translations.count[lang]"
                                  hide-details
                                ></b-text-field>
                              </div>
                            </v-card>
                          </div>

                          <span
                            v-if="selectedRewards.length > 1"
                            class="column-drag-handle pa-4 pl-0 d-flex flex-row"
                            style="float: left; cursor: pointer; z-index: 10"
                          >
                            <v-tooltip color="secondary" top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  color="secondary"
                                  icon
                                  v-on="on"
                                  @click="removeLastSelected(index)"
                                >
                                  <v-icon v-text="icons.mdiClose" size="30"></v-icon>
                                </v-btn>
                              </template>

                              <span
                                class="font-weight-bold"
                                v-text="translations.deactivate[lang]"
                              ></span>
                            </v-tooltip>
                          </span>
                        </v-card>
                      </v-hover>
                    </v-col>
                  </div>
                </Draggable>
                <Draggable
                  class="pl-0 transition-all mt-0 transition-mgt-0"
                  style="overflow: visible"
                  :class="this.addBtnClasses"
                >
                  <div
                    style="position: relative"
                    :style="{
                      'min-width': '386px',
                    }"
                    class="ml-4 d-flex justify-center mxh-100"
                  >
                    <v-col
                      style="cursor: pointer"
                      class="draggable-item rounded-pill mb-10 pl-0"
                      cols="12"
                      sm="12"
                    >
                      <v-card
                        style="max-height: 70px; max-width: 600px"
                        :style="{
                          'min-width': '350px',
                          'max-width': '600px',
                        }"
                        :elevation="4"
                        class="mx-auto pl-2 ml-4 d-flex flex-row align-center rounded-pill transition-all"
                        :class="['rounded-l-lg', 'background-empty']"
                      >
                        <div
                          class="pa-6 pl-2 d-flex flex-row justify-center align-items-center pr-0"
                          style="min-width: 100px; width: 90%"
                        >
                          <v-card
                            v-show="showAddBtn"
                            color="rgba(255,255,255,0)"
                            flat
                            class="d-flex flex-row justify-center align-center ml-0 pl-2 pr-2 mw-100 transition-all"
                            :class="[' font-weight-bold']"
                          >
                            <v-tooltip v-show="showAddBtn" color="secondary" top>
                              <template v-slot:activator="{ on }">
                                <v-btn
                                  v-show="showAddBtn"
                                  class="text-capitalize"
                                  depressed
                                  fab
                                  v-on="on"
                                  @click="addNewSelected()"
                                >
                                  <v-icon size="50" v-text="icons.mdiPlus"></v-icon>
                                </v-btn>
                              </template>
                              <span
                                class="font-weight-bold"
                                v-text="translations.addNew[lang]"
                              ></span>
                            </v-tooltip>
                          </v-card>
                        </div>
                      </v-card>
                    </v-col>
                  </div>
                </Draggable>
              </Container>
            </v-col>
          </v-col>
        </v-row>
      </v-card-text>
    </div>
  </v-card>
</template>

<script>
import {
  mdiArrowLeft,
  mdiArrowRight,
  mdiPencilOutline,
  mdiWindowClose,
  mdiVolumeOff,
  mdiArrowDownBold,
  mdiMenuUp,
  mdiMenuDown,
  mdiEmailOutline,
  mdiMessageReplyTextOutline,
  mdiMessageTextOutline,
  mdiBellOutline,
  mdiInformationVariant,
  mdiPlus,
  mdiClose,
} from '@mdi/js';
import { mapMutations, mapState, mapActions } from 'vuex';
import debounce from 'lodash/debounce';
import moment from 'moment';
import translations from '@/utils/translations/loyaltyPanel/campaigns/newCampaign';
import { Container, Draggable } from 'vue-dndrop';
// import RewardForm from "@/components/loyaltyPanel/newCampaign/RewardForm.vue";
// import { Icon } from "@iconify/vue2";

export default {
  name: 'Step3',

  mixins: [translations],

  components: {
    Container,
    Draggable,
    // Icon
  },

  data: () => ({
    icons: {
      mdiArrowLeft,
      mdiArrowRight,
      mdiPencilOutline,
      mdiArrowDownBold,
      mdiWindowClose,
      mdiVolumeOff,
      mdiMenuUp,
      mdiMenuDown,
      mdiEmailOutline,
      mdiMessageReplyTextOutline,
      mdiMessageTextOutline,
      mdiBellOutline,
      mdiInformationVariant,
      mdiPlus,
      mdiClose,
    },
    hover: false,
    dates: [],
    validPriority: false,
    selectedRewards: [
      {
        reward_id: null,
        count: 1,
        priority: 1,
      },
    ],
    selectedRewardsData: [],
    rewardDialog: false,
    testDialog: false,
    rewardLoading: false,
    searchRewards: '',
    // hasPriority: true,
    modalReward: {},
    modalRewardIndex: null,
    // selectedTab: 'priority',
    page: 1,
    removingLastSelected: false,
    addBtnClasses: ['invisible'],
    showAddBtn: false,
  }),

  computed: {
    ...mapState('loyaltyPanel/campaigns/newCampaign', [
      'systemNotifications',
      'canGoToNextStep',
      'step',
      'allRewards',
      'allRewardsPagination',
    ]),

    ...mapState(['loading']),

    lang() {
      return this.$route.params.lang;
    },

    newCampaign: {
      get() {
        return this.$store.state.loyaltyPanel.campaigns.newCampaign.newCampaign;
      },
      set(val) {
        this.setNewCampaign(val);
      },
    },

    addBtnHeadClasses() {
      let classes = [...this.addBtnClasses].map((e) => (e == 'far-east1' ? 'wild-west1' : e));

      return classes;
    },

    activeRewards() {
      return this.allRewards.filter((x) => x.active) || [];
    },

    validRewards() {
      return this.activeRewards.filter((x) => x.valid) || [];
    },

    lastPriority() {
      return Math.max(...this.selectedRewards.map((r) => r.priority));
    },
    query() {
      if (this.searchRewards) {
        return `?q=${this.searchRewards}&page=${this.page}`;
      }

      return `?page=${this.page}`;
    },
    allAvailableRewards() {
      let rewardIds = this.selectedRewards.map((e) => e.reward_id);
      return this.allRewards.filter((e) => !rewardIds.includes(e.reward_id));
    },
    filteredRewards() {
      if (!this.searchRewards) return this.allAvailableRewards;
      const q = this.searchRewards.toString().toLowerCase();
      return this.allAvailableRewards.filter((r) => {
        const title = (r.title || '').toString().toLowerCase();
        return title.includes(q);
      });
    },
  },

  methods: {
    ...mapActions('loyaltyPanel/campaigns/newCampaign', ['getAllRewards']),
    ...mapMutations('loyaltyPanel/campaigns/newCampaign', ['setCanGoToNextStep', 'setAllRewards']),

    changeRewardPosition(dropResult) {
      if (
        !this.validRewards
          .map((e) => e.system)
          .includes(this.allRewards[dropResult.removedIndex].system)
      ) {
        this.allRewards = this.applyDrag(this.allRewards, dropResult);
      }
    },

    applyDrag(arr, dragResult) {
      const { removedIndex, addedIndex, payload } = dragResult;

      if (removedIndex === null && addedIndex === null) return arr;

      this.allRewards[removedIndex].priority = addedIndex + 1;

      const result = [...arr];
      let itemToAdd = payload;
      if (removedIndex !== null) {
        itemToAdd = itemToAdd || result.splice(removedIndex, 1)[0];
      }
      if (addedIndex !== null) {
        result.splice(addedIndex, 0, itemToAdd);
      }
      return result;
    },

    ...mapActions('loyaltyPanel/campaigns/newCampaign', ['getCampaignSystemNotifications']),

    onDrop(dropResult) {
      this.allRewards = this.applyDrag(this.allRewards, dropResult);
    },

    activateReward(c, i) {
      this.modalReward = c;
      this.modalRewardIndex = i;
      this.rewardDialog = !c.valid;
      c.active = true;
    },
    closeReward(c, i) {
      c.active = false;
    },
    cancelDialog() {
      this.rewardDialog = false;
    },

    goToNextStep() {
      this.newCampaign.participant_rewards = [...this.selectedRewards];
      if (
        !this.newCampaign.participant_rewards[this.newCampaign.participant_rewards.length - 1]
          .reward_id
      ) {
        this.newCampaign.participant_rewards.splice(
          this.newCampaign.participant_rewards.length - 1,
          1
        );
      }
      this.$emit('next');
    },

    goToPreviousStep() {
      this.$emit('prev');
    },

    checkStepValidity() {
      this.setCanGoToNextStep(false);
      if (!this.selectedRewards[0].reward_id) {
        return;
      }
      let validRewards = true;
      this.selectedRewards.forEach((e) => {
        if (e.reward_id && !Number(e.count) > 1) {
          validRewards = false;
        }
      });
      if (validRewards) {
        this.setCanGoToNextStep(true);
      }
    },
    async loadMoreRewards() {
      this.page++;
      const body = {
        query: this.query,
        page: this.page,
      };
      await this.getAllRewards(body);
    },

    endIntersectRewards(entries, observer, isIntersecting) {
      if (
        isIntersecting &&
        this.allRewards &&
        this.allRewards.length < this.allRewardsPagination.total
      ) {
        this.loadMoreRewards();
      }
    },
    handleSearchRewards(i) {
      const body = {
        query: this.query,
        page: this.page,
      };
      this.getAllRewards(body);
    },
    clearRewardIdOnNull(r) {
      r.reward_id = null;
      this.searchRewards = '';
    },
    saveRewardData(i, r) {
      if (!this.selectedRewardsData.find((x) => x.reward_id == r.reward_id))
        this.selectedRewardsData.push(
          this.allRewards.find((x) => x.reward_id == r.reward_id) || {
            reward_id: null,
          }
        );
    },
    getRewardData(r) {
      return this.selectedRewardsData.find((x) => x.reward_id == r.reward_id) || {};
    },
    addNewSelected() {
      this.selectedRewards.push({
        reward_id: null,
        priority: this.selectedRewards.length + 1,
        count: 1,
      });
      this.addBtnClasses.push('far-east1', 'mgt-n100', 'invisible');
      setTimeout(() => {
        this.addBtnClasses = ['invisible'];
        this.showAddBtn = false;
      }, 1000);
    },
    removeLastSelected(index) {
      this.removingLastSelected = true;
      setTimeout(() => {
        this.selectedRewards.splice(index, 1);
        this.removingLastSelected = false;
      }, 0);
    },
  },

  async mounted() {
    this.rewardLoading = true;
    const body = {
      query: this.query,
      page: this.page,
    };
    await this.getAllRewards(body);
    this.rewardLoading = false;
    // this.newCampaign.notifier_type = this.selectedTab == 'none'? null : this.selectedTab
  },
  created() {
    this.debouncedSearchRewards = debounce(this.handleSearchRewards, 500);
  },

  watch: {
    step: {
      immediate: true,
      handler(val) {
        if (val == 5) {
          this.checkStepValidity();
        }
      },
    },
    searchRewards() {
      this.page = 1;
      this.debouncedSearchRewards();
    },
    selectedRewards: {
      deep: true,
      handler(val, oldVal) {
        this.checkStepValidity();
        if (!val[val.length - 1].reward_id) {
          this.addBtnClasses.push('invisible');
          if (val.length > oldVal.length) {
            this.addBtnClasses.push('far-east');
          }
          setTimeout(() => {
            this.showAddBtn = false;
          }, 1200);
        } else {
          this.addBtnClasses = [];
          this.showAddBtn = true;
        }
      },
    },
  },
};
</script>

<style>
.priority-tabs .v-slide-group__wrapper {
  border-radius: 9999px !important;
  box-shadow:
    0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
}
.priority-tabs .v-tabs-slider-wrapper {
  /* display: none; */
  color: black !important;
  caret-color: black !important;
}
.no-messages .v-messages {
  display: none;
}
.hover-bold:hover {
  font-weight: 600;
  text-shadow: black 1px 0 10px;
}
</style>

<style scoped>
.no-priority-card {
  width: 25%;
}
.no-priority-card1 {
  margin-left: 33% !important;
  margin-top: -134px !important;
}
.no-priority-card2 {
  margin-left: 66% !important;
  margin-top: -198px !important;
}
.invisible {
  opacity: 0;
  pointer-events: none;
}
.no-right-shadow {
  clip-path: inset(-5px 0px -5px -5px);
}
.no-left-shadow {
  clip-path: inset(-5px -5px -5px 0px);
}
.far-east {
  margin-left: 42222px;
}
.wild-west0 {
  margin-left: -2222px;
}
.wild-west1 {
  margin-left: -4222px;
}
.wild-west2 {
  margin-left: -6222px;
}
.far-north0 {
  margin-left: 200px !important;
  margin-top: -4222px !important;
}
.far-north1 {
  margin-left: 4222px !important;
  margin-top: -6222px !important;
}
.far-east1 {
  margin-left: 4222px;
}
.transition-all {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 2s,
    background-color 2s;
}
.transition-all * {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 2.5s,
    background-position 1.5s,
    opacity 2s,
    background-color 2s;
}
.transition-mgt-0 * {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 0s,
    background-position 1.5s,
    opacity 2s,
    background-color 2s;
}
.transition-mgt-0 {
  transition:
    all 0.5s,
    width 2s,
    max-width 1s,
    min-width 1s,
    margin-left 2s,
    margin-top 0s,
    background-position 1.5s,
    opacity 2s,
    background-color 2s;
}
.background-fill-transition-valid {
  background: linear-gradient(to right, rgba(60, 179, 113, 0.5) 50%, white 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.background-fill-transition-error {
  background: linear-gradient(to right, rgba(255, 46, 46, 0.75) 50%, white 50%);
  background-size: 201% 101%;
  background-position: left top;
}
.background-fill-transition {
  background: linear-gradient(to left, white 50%, white 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.background-fill-left {
  background-position: left bottom;
}

.background-fill-valid {
  background: linear-gradient(to right, rgba(60, 179, 113, 0.5) 50%, rgba(60, 179, 113, 0.5) 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.background-fill-error {
  background: linear-gradient(to right, rgba(255, 46, 46, 0.75) 50%, rgba(255, 46, 46, 0.75) 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}

.background-empty {
  background: linear-gradient(to right, white 50%, white 50%);
  background-size: 201% 101%;
  background-position: right bottom;
}
.priority-tab-active {
  font-weight: 550;
  color: rgba(0, 0, 0, 0.9);
  /* background: rgba(60, 179, 113, 0.5); */
  background: primary;
  border-bottom: none;
  box-shadow:
    0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14),
    0px 1px 10px 0px rgba(0, 0, 0, 0.12) !important;
  /* background-size: 201% 101%;
    background-position: right bottom; */
}
.info-icon {
  font-size: 18px !important;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 9999px;
  border: 0px solid black;
}
.mxh-0 {
  max-height: 0 !important;
}
.mxh-100 {
  max-height: 100%;
}
.mgt-n100 {
  margin-top: -100px !important;
}
</style>
